import { useEffect, useState } from "react";
import { useGetAssignmentsQuery } from "../../redux/features/assignments/assignmentAPI";
import { useGetQuizzesQuery } from "../../redux/features/quiz/quizAPI";
import { useGetAssignmentMarksQuery } from "../../redux/features/assignments/assignmentMarkAPI";
import { useGetQuizMarksQuery } from "../../redux/features/quiz/quizMarkAPI";
import { useNavigate, useParams } from "react-router-dom";
import { dateformatter } from "../../utils/dateformatter";
import AssignmentModal from "../../components/AssignmentModal";
import SideBar from "../../components/SideBar";
import usePageTitle from "../../utils/usePageTitle";
import {
  useGetVideoQuery,
  useGetVideosQuery,
} from "../../redux/features/videos/videosAPI";

export default function CoursePlayer() {
  usePageTitle("Dashboard");

  const { videoId, studentId: sId } = useParams();
  const [studentId, setStudentId] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const { id } = JSON.parse(localStorage.auth).user;
    setStudentId(id);

    if (id === 1) navigate("/admin");
    if (id !== Number(sId)) navigate("/");
  }, [navigate, sId]);

  const {
    data: videos,
    isLoading: videosIsLoading,
    isError: videosIsError,
    error: videosError,
  } = useGetVideosQuery();

  const {
    data: selectedVideo,
    isLoading: selectedVideoIsLoading,
    isError: selectedVideoIsError,
  } = useGetVideoQuery(videoId);

  const {
    data: assignments,
    isLoading: assignmentsIsLoading,
    isError: assignmentsIsError,
  } = useGetAssignmentsQuery();

  const {
    data: quizzes,
    isLoading: quizzesIsLoading,
    isError: quizzesIsError,
  } = useGetQuizzesQuery();

  const {
    data: assignmentMarks,
    isLoading: assignmentMarksIsLoading,
    isError: assignmentMarksIsError,
  } = useGetAssignmentMarksQuery();

  const {
    data: quizMarks,
    isLoading: quizMarksIsLoading,
    isError: quizMarksIsError,
  } = useGetQuizMarksQuery();

  const decideAssignmentButton = (assignment) => {
    const { id: assignment_id } = assignment;

    if (
      !assignmentMarksIsLoading &&
      !assignmentMarksIsError &&
      assignmentMarks?.length > 0
    ) {
      const submission = assignmentMarks.find(
        (assignment) =>
          assignment.assignment_id === Number(assignment_id) &&
          assignment.student_id === Number(studentId)
      );
      return submission ? true : false;
    }
  };

  const decideQuizButton = (quiz) => {
    const { video_id: quizVideoId } = quiz;

    if (!quizMarksIsLoading && !quizMarksIsError && quizMarks?.length > 0) {
      const submission = quizMarks.find(
        (quiz) =>
          quiz.video_id === Number(quizVideoId) &&
          quiz.student_id === Number(studentId)
      );
      return submission ? true : false;
    }
  };

  const [selectedAssignment, setSelectedAssignment] = useState({});
  const [assignmentModalOpened, setAssignmentModalOpened] = useState(false);

  const controlAssignmentModal = (assignment) => {
    setAssignmentModalOpened((prevState) => !prevState);
    setSelectedAssignment(assignment);
  };

  let content = null;
  let assignmentButton = null;
  let quizButton = null;

  if (videosIsLoading) content = <div>Loading...</div>;
  if (!videosIsLoading && videosIsError) content = <div>{videosError}</div>;
  if (!videosIsLoading && !videosIsError && videos?.length === 0)
    content = <div>No Videos Found!</div>;

  if (!videosIsLoading && !videosIsError && videos?.length > 0) {
    content = videos.map((video) => (
      <SideBar key={video.id} video={video} studentId={studentId} />
    ));
  }

  if (
    !selectedVideoIsLoading &&
    !selectedVideoIsError &&
    !assignmentsIsLoading &&
    !assignmentsIsError &&
    assignments?.length > 0
  ) {
    const selectedAssignment = assignments.find(
      (assignment) => assignment.video_id === Number(selectedVideo.id)
    );

    assignmentButton = selectedAssignment ? (
      <button
        onClick={() => controlAssignmentModal(selectedAssignment)}
        disabled={decideAssignmentButton(selectedAssignment)}
        className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
      >
        এসাইনমেন্ট
      </button>
    ) : null;
  }

  if (
    !selectedVideoIsLoading &&
    !selectedVideoIsError &&
    !quizzesIsLoading &&
    !quizzesIsError &&
    quizzes?.length > 0
  ) {
    const selectedQuiz = quizzes.find(
      (quiz) => quiz.video_id === Number(selectedVideo.id)
    );

    quizButton = selectedQuiz ? (
      <button
        disabled={decideQuizButton(selectedQuiz)}
        onClick={() =>
          navigate(`/student/${studentId}/quiz/${selectedVideo.id}`)
        }
        className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
      >
        কুইজে অংশগ্রহণ করুন
      </button>
    ) : null;
  }

  return (
    <>
      {/* <Navbar /> */}
      <AssignmentModal
        open={assignmentModalOpened}
        control={controlAssignmentModal}
        assignment={selectedAssignment}
      />
      <section className="py-6 bg-primary mt-8">
        <div
          className="mx-auto max-w-7xl px-5 lg:px-0"
          style={{
            paddingTop: "2%",
          }}
        >
          <div className="grid grid-cols-3 gap-2 lg:gap-8">
            <div className="col-span-full w-full space-y-8 lg:col-span-2">
              <iframe
                width="100%"
                className="aspect-video border border-slate-600/50"
                src={selectedVideo?.url}
                title={selectedVideo?.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>

              <div>
                <h1 className="text-lg font-semibold tracking-tight text-slate-100">
                  {selectedVideo?.title}
                </h1>
                <h2 className="pb-4 text-sm leading-[1.7142857] text-slate-400">
                  Uploaded on {dateformatter(selectedVideo?.createdAt)}
                </h2>

                <div className="flex gap-4">
                  {assignmentButton} {quizButton}
                </div>
                <p className="mt-4 text-sm text-slate-400 leading-6 border-t border-slate-600/50 pt-4">
                  {selectedVideo?.description}
                </p>
              </div>
            </div>
            <div className="rounded bg-primary font-medium text-white col-span-full lg:col-auto max-h-[530px] overflow-y-auto bg-secondary p-4 border border-slate-50/10 divide-y divide-slate-600/30 h-auto">
              {content}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
